module.exports = __webpack_public_path__ + "img/CATEGORY ICON-12.0f6f1024.png";